import { styled } from 'styled-components';
import { Image } from '@/shared/ui/image/Image';

const OptionIcon = styled(Image)`
  img {
    width: 48px;
    height: 48px;
  }

  @media (max-width: 768px) {
    img {
      width: 40px;
      height: 40px;
    }
  }
`;

const WrapperOptions = styled.div`
  display: flex;
  gap: 12px;
  flex-direction: column;
`;

const OptionItem = styled.div<{ $isActive?: boolean }>`
  align-items: center;
  display: flex;
  gap: 12px;
  padding: 8px 12px;
  border-radius: 5px;
  background: rgba(61, 60, 65, 0.5);
  cursor: pointer;
  flex-wrap: wrap;
  text-align: left;

  ${({ $isActive }) =>
    $isActive &&
    `
    border: 2px solid #FF9F0A;
    background: rgba(255, 159, 10, 0.10);
    `}
`;

const InfoEl = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
`;

export { WrapperOptions, OptionItem, InfoEl, OptionIcon };
